import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="relative overflow-hidden border-b-4 border-brandorange bg-carbon" data-id="element-72" data-mp="9ktchjcqjuvn">
      <div className="grid-tech absolute inset-0 opacity-40" aria-hidden="true" data-id="element-73" data-mp="9igwvcug9wlr" />
      <div className="relative mx-auto max-w-[1080px] px-4 pb-8 pt-7 sm:px-6 sm:pb-10 sm:pt-9" data-id="element-74" data-mp="4njq6ckn7zc1">
        <div className="mx-auto mb-4 flex w-fit items-center gap-2 border border-brandorange bg-brandorange/10 px-3 py-1" data-id="element-75" data-mp="128phdbcgkt3i">
          <span className="h-1.5 w-1.5 bg-brandorange" aria-hidden="true" data-id="element-76" data-mp="x8jj3cboo8cg" />
          <span className="font-display text-[11px] uppercase tracking-[0.2em] text-white sm:text-xs" data-id="element-77" data-mp="s9gic42qkoaa">
            For motorcycle technicians
          </span>
        </div>

        <h1 className="mx-auto max-w-[900px] text-center text-[30px] font-bold leading-[0.98] text-white sm:text-[46px] lg:text-[58px]" data-id="element-78" data-mp="3d2bjjokooxv0">
          The Complete Visual Troubleshooting System{' '}
          <span className="text-brandorange" data-id="element-79" data-mp="3j9kbdcsl9jgn">For Motorcycle Technicians</span>
        </h1>

        <p className="mx-auto mt-3 max-w-[760px] text-center text-[14px] font-medium leading-snug text-metal sm:text-[17px]" data-id="element-80" data-mp="3o7vhbcfrj9tl">
          Stop jumping between scattered references every time a motorcycle fault
          appears. Use organized diagnostic workflows, system references and
          troubleshooting tools to identify faults and follow a clearer diagnostic
          process.{' '}
          <strong className="font-bold text-white" data-id="element-81" data-mp="358zq89z7bbjz">
            Identify. Test. Diagnose with confidence.
          </strong>
        </p>

        <MockupImage className="mt-5 sm:mt-6" priority data-id="element-82" data-mp="2qlofuber9xlg" />

        <div className="mt-5 flex flex-col items-center" data-id="element-83" data-mp="2vi53l4i1m9y0">
          <CTAButton href={OFFER_ANCHOR} data-id="element-84" data-mp="2vglmjbokbuv6">
            🏍️ Yes! I want the complete system
          </CTAButton>
          <p className="mt-3 text-center font-display text-[11px] uppercase tracking-wide text-metal sm:text-[13px]" data-id="element-85" data-mp="2lkqyg11kl7l0">
            Get Motorcycle Diagnostic Pro™ today{' '}
            <span className="mx-1 text-line" data-id="element-86" data-mp="s3cm2bn71lr3">|</span> 🛡️ 7-Day Money-Back
            Guarantee <span className="mx-1 text-line" data-id="element-87" data-mp="n9qira2x6u7y">|</span> ⚡ Complete 6-in-1
            System
          </p>
        </div>
      </div>
    </section>;
}